import styles from "./index.module.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const WarningStep = () => {
    const { t } = useTranslation();

    const [warningList] = useState<string[]>(
        t("account-delete:deletion-warning-list", { returnObjects: true })
    );

    return (
        <div className={styles["warning-step-container"]}>
            <h5>{t("account-delete:reminder")}</h5>
            <p>{t("account-delete:deletion-warning")}</p>
            <ul>
                {warningList.map((i, idx) => (
                    <li key={idx}>{i}</li>
                ))}
            </ul>
            <p>{t("account-delete:download-assets")}</p>
        </div>
    );
};
